import {zapi} from '../__internal__/http-client/index.js';

import * as endpoints from './endpoints.js';

/**
 * @see https://developer.zattoo.com/display/ZAPI/2.2.1+-+Session+Management#2.2.1-SessionManagement-v3hello
 * @param {$ZAPI.Session.HelloRequestV3} data
 * @returns {Promise<$ZAPI.Session.SessionResponseV3>}
 */
export const helloSessionV3 = (data) => zapi({
    path: 'v3/session/hello',
    method: 'post',
    endpointID: endpoints.SESSION_V3_HELLO_COMPLETED,
    data,
});

/**
 * @returns {Promise<$ZAPI.Session.SessionResponseV3>}
 */
export const goodbyeSessionV3 = () => zapi({
    path: 'v3/session/goodbye',
    method: 'post',
    endpointID: endpoints.SESSION_V3_GOODBYE_COMPLETED,
});

/**
 * @see https://developer.zattoo.com/display/ZAPI/2.2.1+-+Session+Management#2.2.1-SessionManagement-v3getsession
 * @returns {Promise<$ZAPI.Session.SessionResponseV3>}
 */
export const getSessionV3 = () => zapi({
    path: 'v3/session',
    method: 'get',
    endpointID: endpoints.SESSION_V3_RECEIVED,
});

/**
 * @see https://developer.zattoo.com/display/ZAPI/2.2.1+-+Session+Management#2.2.1-SessionManagement-v3updatesession
 * @param {$ZAPI.Session.UpdateRequest} data
 * @returns {Promise<$ZAPI.Session.SessionResponseV3>}
 */
export const updateSessionV3 = (data) => zapi({
    path: 'v3/session/update',
    method: 'post',
    endpointID: endpoints.SESSION_V3_UPDATED,
    data,
});

/**
 * @returns {Promise<$ZAPI.Session.CCSInfoResponse>}
 */
export const getCCSInfo = () => zapi({
    path: 'v3/session/ccs_info',
    method: 'get',
    endpointID: endpoints.SESSION_CCS_INFO_RECEIVED,
});

/**
 * @param {$ZAPI.Session.SetPartnerRequest} data
 * @returns {Promise<$ZAPI.Response.SuccessResponse>}
 */
export const setPartner = (data) => zapi({
    path: 'session/partner/set',
    method: 'post',
    endpointID: endpoints.SESSION_PARTNER_SET,
    data,
});

/**
 * @returns {Promise<$ZAPI.Response.SuccessResponse>}
 */
export const unsetPartner = () => zapi({
    path: 'session/partner/unset',
    method: 'post',
    endpointID: endpoints.SESSION_PARTNER_UNSET,
});

/**
 * @param {$ZAPI.Session.SetDiscountCodeRequest} data
 * @returns {Promise<$ZAPI.Session.SetDiscountResponse>}
 */
export const setDiscountCode = (data) => zapi({
    path: 'session/discount_code/set',
    method: 'post',
    endpointID: endpoints.SESSION_DISCOUNT_CODE_SET,
    data,
});

/**
 * @deprecated use {@link helloSessionV3}
 * @see https://developer.zattoo.com/display/ZAPI/2.2.1+-+Session+Management#2.2.1-SessionManagement-v2hello
 * @param {$ZAPI.Session.HelloRequestV2} data
 * @returns {Promise<$ZAPI.Session.SessionResponseV2>}
 */
export const helloSessionV2 = (data) => zapi({
    path: 'v2/session/hello',
    method: 'post',
    endpointID: endpoints.SESSION_V2_HELLO_COMPLETED,
    data,
});

/**
 * @deprecated use {@link goodbyeSessionV3}
 * @see https://developer.zattoo.com/display/ZAPI/2.2.1+-+Session+Management#2.2.1-SessionManagement-v2goodbye
 * @returns {Promise<$ZAPI.Session.SessionResponseV2>}
 */
export const goodbyeSessionV2 = () => zapi({
    path: 'v2/session/goodbye',
    method: 'post',
    endpointID: endpoints.SESSION_V2_GOODBYE_COMPLETED,
});

/**
 * @deprecated use {@link getSessionV3}
 * @see https://developer.zattoo.com/display/ZAPI/2.2.1+-+Session+Management#2.2.1-SessionManagement-v2getsession
 * @returns {Promise<$ZAPI.Session.SessionResponseV2>}
 */
export const getSessionV2 = () => zapi({
    path: 'v2/session',
    method: 'get',
    endpointID: endpoints.SESSION_V2_RECEIVED,
});
